import { Branches } from "redux/constants/Branches";

const initState = {
  data: [],
  loading: false,
};

const branches = (state = initState, action) => {
  switch (action.type) {
    case Branches.LOADING_BRANCHES_LIST:
      return {
        ...state,
        loading: action.payload,
      };
    case Branches.GET_BRANCHES_LIST:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default branches;